module.exports = __webpack_public_path__ + "img/misa-amis.3a0d2d1c.jpeg";